import React from "react";

export default function IconPlususer() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1052_26)">
        <path
          d="M7.36342 10.5201C7.95385 10.5201 8.53791 10.5901 9.106 10.728C8.97529 10.9168 8.85397 11.1123 8.74287 11.3144C8.63471 11.5112 8.53588 11.7139 8.44752 11.9221C8.10752 12.7234 7.91932 13.6041 7.91932 14.528C7.91932 15.4896 8.12357 16.4042 8.49037 17.2315C8.58971 17.4555 8.70088 17.6733 8.82334 17.8837C8.95486 18.1097 9.09912 18.3275 9.25537 18.5359H0.652051C0.291895 18.5359 -0.000137329 18.2439 -0.000137329 17.8837C-0.000137329 13.8234 3.30318 10.5201 7.36342 10.5201Z"
          fill="white"
        />
        <path
          d="M9.44012 13.0158C10.0954 10.7786 12.1657 9.13989 14.6119 9.13989C17.5829 9.13993 20 11.557 20 14.5281C20 17.4991 17.5829 19.9161 14.6119 19.9161C12.2811 19.9161 10.2914 18.4283 9.54203 16.3526C9.33629 15.7825 9.22383 15.1682 9.22383 14.528C9.22383 14.0032 9.29957 13.4958 9.44012 13.0158ZM12.5985 15.1802H13.9598V16.5415C13.9598 16.9017 14.2518 17.1937 14.612 17.1937C14.9721 17.1937 15.2641 16.9017 15.2641 16.5415V15.1802H16.6254C16.9855 15.1802 17.2775 14.8883 17.2775 14.5281C17.2775 14.1679 16.9855 13.8759 16.6254 13.8759H15.2641V12.5146C15.2641 12.1544 14.9721 11.8624 14.6119 11.8624C14.2518 11.8624 13.9597 12.1544 13.9597 12.5146V13.8759H12.5984C12.2383 13.8759 11.9462 14.1679 11.9462 14.5281C11.9463 14.8882 12.2382 15.1802 12.5985 15.1802Z"
          fill="white"
        />
        <path
          d="M7.36334 0.0838928C9.48998 0.0838928 11.2202 1.81413 11.2202 3.94089C11.2202 6.06749 9.48998 7.7976 7.36334 7.7976C5.2367 7.7976 3.50646 6.06749 3.50646 3.94089C3.50646 1.81413 5.2367 0.0838928 7.36334 0.0838928Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1052_26">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="matrix(-1 0 0 1 20 0)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
